module.exports = __webpack_public_path__ + "static/media/NA.b261ae9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/NA.svg
// module id = 326
// module chunks = 0